module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/8fed622c4d818b24664982cc8590128c.png";